import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { format } from 'date-fns'
import Card from '../../common/cards/Card'
import Badge from '../../common/badge/Badge'
import { BadgeColor } from '../../common/badge/badgeTypes'
import { Pages } from '../../../Pages'
import { type ScreenerListItemUserDto } from '../../../api/kit/KitApi'
import { buildApplyUrl } from '../utils'
import LinkCopyButton from './LinkCopyButton'

type Props = {
    screener: ScreenerListItemUserDto
}

export default function ScreenerCard({ screener }: Props): React.JSX.Element {
    const applyUrl = buildApplyUrl(screener.urlId)

    return (
        <Link to={`${Pages.JobScreener}?id=${screener.id}`} className="block">
            <Card className="cursor-pointer hover:bg-gray-50 flex items-center">
                <div className="flex justify-between w-full">
                    <div className="w-full flex flex-col text-sm text-gray-500">
                        <div className="flex justify-between items-baseline">
                            <div className="font-semibold text-gray-900 text-lg leading-tight mr-2">
                                {screener.jobTitle}
                            </div>
                            <Badge
                                color={
                                    screener.isActive
                                        ? BadgeColor.Success
                                        : BadgeColor.Neutral
                                }
                            >
                                {screener.isActive ? 'Active' : 'Inactive'}
                            </Badge>
                        </div>

                        <div className="flex items-center gap-x-4 mt-1 text-sm text-gray-500">
                            <span>
                                {screener.candidateCount} candidate
                                {screener.candidateCount === 1 ? '' : 's'}
                            </span>
                            <span>
                                {format(
                                    new Date(screener.createdAt),
                                    'd MMM yyyy',
                                )}
                            </span>
                            {applyUrl && (
                                <LinkCopyButton
                                    url={applyUrl}
                                    stopPropagation
                                />
                            )}
                        </div>
                    </div>

                    <div className="flex items-center pl-4">
                        <FontAwesomeIcon
                            icon={faChevronRight}
                            className="text-gray-400"
                        />
                    </div>
                </div>
            </Card>
        </Link>
    )
}
